module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Women Silver + Stone Grey Open.075be95a.png";